import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  Home, Paintbrush, Building2, Flame,
  Maximize2, Hammer, ArrowRight, Shield,
  ChevronRight, Star
} from "lucide-react";
import { Button } from "@/components/ui/button";

const services = [
  {
    name: "Roofing",
    icon: Home,
    image: "https://images.pexels.com/photos/33404981/pexels-photo-33404981.jpeg?auto=compress&cs=tinysrgb&w=800",
    gallery: [
      "https://images.pexels.com/photos/33404248/pexels-photo-33404248.jpeg?auto=compress&cs=tinysrgb&w=600",
      "https://images.unsplash.com/photo-1770044001869-12315d4d6884?w=600&auto=format",
      "https://images.unsplash.com/photo-1755114203680-d39d95efa82c?w=600&auto=format",
    ],
    desc: "Expert roofing installation, repair, and replacement services for residential and commercial properties. We use only premium materials to ensure lasting protection for your home.",
  },
  {
    name: "Painting",
    icon: Paintbrush,
    image: "https://images.pexels.com/photos/36153946/pexels-photo-36153946.jpeg?auto=compress&cs=tinysrgb&w=800",
    gallery: [
      "https://images.pexels.com/photos/16690918/pexels-photo-16690918.jpeg?auto=compress&cs=tinysrgb&w=600",
      "https://images.unsplash.com/photo-1646009653015-602d963494bc?w=600&auto=format",
      "https://images.unsplash.com/photo-1612296350607-076d142d15cd?w=600&auto=format",
    ],
    desc: "Interior and exterior painting services that transform your space with precision and quality finishes. Our skilled painters deliver flawless results every time.",
  },
  {
    name: "Window & Doors",
    icon: Maximize2,
    image: "https://images.unsplash.com/photo-1771968965646-9818a67c186a?w=800&auto=format",
    gallery: [
      "https://images.unsplash.com/photo-1775359924001-9cf0e5d3adf5?w=600&auto=format",
      "https://images.unsplash.com/photo-1723639904216-7302a5d55609?w=600&auto=format",
      "https://images.pexels.com/photos/5691521/pexels-photo-5691521.jpeg?auto=compress&cs=tinysrgb&w=600",
    ],
    desc: "Professional window and door installation and replacement to enhance your home's energy efficiency, security, and curb appeal.",
  },
  {
    name: "Home Additions",
    icon: Building2,
    image: "https://images.unsplash.com/photo-1632143697739-5559b57ac985?w=800&auto=format",
    gallery: [
      "https://images.unsplash.com/photo-1753977725475-41b221add2c0?w=600&auto=format",
      "https://images.unsplash.com/photo-1723470916372-325154109b74?w=600&auto=format",
      "https://images.unsplash.com/photo-1722247520828-d058d57b1313?w=600&auto=format",
    ],
    desc: "Expand your living space with custom home additions designed to seamlessly integrate with your existing structure and increase property value.",
  },
  {
    name: "Fire & Water Restoration",
    icon: Flame,
    image: "https://images.unsplash.com/photo-1632624759923-86919326bd0f?w=800&auto=format",
    gallery: [
      "https://images.unsplash.com/photo-1748816964372-8a73dbb4bb7a?w=600&auto=format",
      "https://images.unsplash.com/photo-1721825157707-58b6c32eaeaf?w=600&auto=format",
      "https://images.pexels.com/photos/12119354/pexels-photo-12119354.jpeg?auto=compress&cs=tinysrgb&w=600",
    ],
    desc: "Swift and thorough fire and water damage restoration to get your property back to its original condition. We handle emergencies promptly.",
  },
  {
    name: "Bonus Rooms",
    icon: Hammer,
    image: "https://images.unsplash.com/photo-1765959617888-30837a158667?w=800&auto=format",
    gallery: [
      "https://images.unsplash.com/photo-1646592491550-6ef7a11ecc58?w=600&auto=format",
      "https://images.unsplash.com/photo-1700588080759-fcc5f249c321?w=600&auto=format",
      "https://images.unsplash.com/photo-1723470916372-325154109b74?w=600&auto=format",
    ],
    desc: "Convert unused spaces like garages, attics, or basements into beautiful bonus rooms that add value and functionality to your home.",
  },
  {
    name: "Driveways",
    icon: ArrowRight,
    image: "https://images.pexels.com/photos/8134845/pexels-photo-8134845.jpeg?auto=compress&cs=tinysrgb&w=800",
    gallery: [
      "https://images.unsplash.com/photo-1628744448839-170bf324f27e?w=600&auto=format",
      "https://images.unsplash.com/photo-1691959821687-24cd8eaef532?w=600&auto=format",
      "https://images.pexels.com/photos/3935333/pexels-photo-3935333.jpeg?auto=compress&cs=tinysrgb&w=600",
    ],
    desc: "Durable driveway installation and repair services using quality materials designed to withstand Memphis weather and heavy use.",
  },
  {
    name: "Fences & More",
    icon: Shield,
    image: "https://images.unsplash.com/photo-1769831190663-95fe8454d8c9?w=800&auto=format",
    gallery: [
      "https://images.unsplash.com/photo-1748908271592-d9d5690b288b?w=600&auto=format",
      "https://images.unsplash.com/photo-1740482682683-309e6fb4898f?w=600&auto=format",
      "https://images.unsplash.com/photo-1719013224662-b2cd65e0d128?w=600&auto=format",
    ],
    desc: "Custom fence installation, decking, and additional exterior improvements to enhance your property's security and aesthetics.",
  },
];

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      {/* Header */}
      <section className="bg-brand-dark py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="font-outfit text-sm font-bold tracking-[0.2em] uppercase text-brand block mb-3">
              What We Offer
            </span>
            <h1 className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter uppercase text-white">
              Our Services
            </h1>
          </motion.div>
        </div>
      </section>

      {/* Financing Banner */}
      <div className="bg-brand py-4">
        <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-center gap-3">
          <Star className="w-5 h-5 text-white fill-white" />
          <span className="font-outfit font-bold text-white uppercase tracking-wider text-sm">
            Financing Available on All Services
          </span>
          <Star className="w-5 h-5 text-white fill-white" />
        </div>
      </div>

      {/* Services Grid */}
      <section className="py-20 md:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="space-y-0">
            {services.map((service, i) => {
              const Icon = service.icon;
              const isEven = i % 2 === 0;
              const serviceId = service.name.toLowerCase().replace(/[&\s]+/g, "-");
              return (
                <motion.div
                  key={service.name}
                  id={serviceId}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                  data-testid="service-card"
                  className="grid grid-cols-1 lg:grid-cols-2 border-b border-neutral-200 last:border-b-0 scroll-mt-24"
                >
                  <div
                    className={`overflow-hidden ${
                      isEven ? "lg:order-1" : "lg:order-2"
                    }`}
                  >
                    <img
                      src={service.image}
                      alt={service.name}
                      className="w-full h-64 lg:h-72 object-cover hover:scale-105 transition-transform duration-500"
                    />
                    <div className="grid grid-cols-3 gap-1">
                      {service.gallery.map((img, j) => (
                        <img
                          key={j}
                          src={img}
                          alt={`${service.name} project ${j + 1}`}
                          className="w-full h-24 lg:h-28 object-cover hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      ))}
                    </div>
                  </div>
                  <div
                    className={`flex flex-col justify-center p-8 lg:p-16 ${
                      isEven ? "lg:order-2" : "lg:order-1"
                    }`}
                  >
                    <h2 className="font-outfit text-2xl sm:text-3xl font-bold tracking-tight text-brand-dark mb-4">
                      {service.name}
                    </h2>
                    <p className="font-dm-sans text-base text-neutral-600 leading-relaxed mb-6">
                      {service.desc}
                    </p>
                    <Link to="/contact" className="inline-flex items-center gap-2">
                      <Button className="bg-brand text-white font-outfit font-bold uppercase tracking-wider text-xs px-6 py-5 hover:bg-brand-hover rounded-none">
                        Request Quote
                        <ChevronRight className="w-4 h-4 ml-1" />
                      </Button>
                    </Link>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-24 bg-brand-dark">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h2 className="font-outfit text-3xl sm:text-4xl font-bold tracking-tight uppercase text-white mb-4">
            Need a Custom Solution?
          </h2>
          <p className="font-dm-sans text-neutral-400 mb-8 max-w-md mx-auto">
            We handle projects of all sizes. Contact us to discuss your needs.
          </p>
          <Link to="/contact">
            <Button className="bg-brand text-white font-outfit font-bold uppercase tracking-wider text-sm px-10 py-6 hover:bg-brand-hover rounded-none">
              Contact Us Today
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
